import { Box, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/if"
import { Else } from "lib/@components/else"
import { TaskRow } from "./task-row"

export function PreviewTaskRow({ item: task }) {
    return (
        <Box mb={2}>
            <If truthy={task.isHeader}>
                <Box sx={{ bgcolor: "action.selected", borderRadius: 1, p: 1, mb: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {task.position}.
                        </Typography>
                        <Typography variant="body2" fontWeight="bold">
                            {task.title}
                        </Typography>
                    </Stack>
                </Box>
                <Else>
                    <TaskRow task={task} />
                </Else>
            </If>
        </Box>
    )
}
